import { Link as ScrollLink } from "react-scroll";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import data from "../data/siteData.json";
import "./Navbar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isHome = location.pathname === "/";

  const handleNavClick = (id) => {
    setMenuOpen(false);

    if (isHome) {
      // already on home → scroll
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      // go home first, then scroll
      navigate("/", { state: { scrollTo: id } });
    }
  };

  return (
    <header className="navbar">
      <div className="nav-container">

        {/* Logo */}
        <div className="nav-logo">
          {isHome ? (
            <ScrollLink to="home" smooth duration={700} offset={-90}>
              <img src={data.logo} alt="Logo" />
            </ScrollLink>
          ) : (
            <Link to="/">
              <img src={data.logo} alt="Logo" />
            </Link>
          )}
        </div>

        {/* Desktop Menu */}
        <nav className="nav-menu desktop-menu">
          {data.menu.map((item, index) => (
            <button
              key={index}
              className="underline-btn"
              onClick={() => handleNavClick(item.id)}
            >
              {item.name}
            </button>
          ))}
        </nav>

        {/* Call */}
        <div className="nav-call desktop-menu">
          <a href={`tel:${data.contactNumber}`} className="phone-link">
            📞 {data.contactNumber}
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="mob-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <nav className="mobile-menu">
          {data.menu.map((item, index) => (
            <button
              key={index}
              className="mobile-link"
              onClick={() => handleNavClick(item.id)}
            >
              {item.name}
            </button>
          ))}
          <a href={`tel:${data.contactNumber}`} className="mobile-call">
            📞 {data.contactNumber}
          </a>
        </nav>
      )}
    </header>
  );
}
